import { Fade } from '@mui/material';

import ButtonV2 from '../../../../button/button-v2/button-v2.component';
import {
  SubmissionConfirmationButton,
  SubmissionConfirmationContainer,
  SubmissionConfirmationContent,
  SubmissionConfirmationHeader,
  SubmissionConfirmationTitle,
} from './submission-confirmation.styles';
import { ISubmissionConfirmationProps } from './submission-confirmation.types';

export default function SubmissionConfirmation({
  title = "We've received your submission.",
  message = "You'll have the next 30-minutes to make any changes before our agents begin processing your search.",
  actionTitle = 'OK',
  handleAction,
  handleClose,
  isActionLoading,
}: ISubmissionConfirmationProps) {
  return (
    <SubmissionConfirmationContainer
      open
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Fade}
      onClick={e => e.stopPropagation()}
    >
      <SubmissionConfirmationHeader>
        <SubmissionConfirmationTitle>{title}</SubmissionConfirmationTitle>
      </SubmissionConfirmationHeader>

      <SubmissionConfirmationContent>{message}</SubmissionConfirmationContent>

      {/* Single OK button for both admin and regular users */}
      <SubmissionConfirmationButton>
        <ButtonV2
          customVariant="secondary-small"
          title={actionTitle as string}
          handleClick={handleAction}
          className="action-button"
          isLoading={isActionLoading}
          sx={{ width: '120px' }}
        />
      </SubmissionConfirmationButton>
    </SubmissionConfirmationContainer>
  );
}
